const PRESETS = {
    ALL: { min_age_months: null, max_age_months: null },
    PEDIATRIE: { min_age_months: 0, max_age_months: 179 },
    ADULTE: { min_age_months: 180, max_age_months: 780 },
    GERIATRIE: { min_age_months: 781, max_age_months: null }
}

function toMonths(value, unit) {
    if (value === '' || value === null || value === undefined) return null
    const number = Number(value)
    if (!Number.isInteger(number) || number < 0) throw new Error('Saisissez un âge entier positif ou nul.')
    const months = unit === 'ans' ? number * 12 : number
    if (months > 1800) throw new Error('L’âge ne peut pas dépasser 150 ans.')
    return months
}

export function ageRange(fields) {
    if (Object.prototype.hasOwnProperty.call(PRESETS, fields.mode)) return { ...PRESETS[fields.mode] }
    if (fields.mode !== 'CUSTOM') throw new Error('Sélectionnez une tranche d’âge valide.')
    const min_age_months = toMonths(fields.minValue, fields.minUnit)
    const max_age_months = toMonths(fields.maxValue, fields.maxUnit)
    if (min_age_months !== null && max_age_months !== null && min_age_months > max_age_months) {
        throw new Error('L’âge maximum doit être supérieur ou égal à l’âge minimum.')
    }
    return { min_age_months, max_age_months }
}

function inputFor(months) {
    if (months === null || months === undefined || months === '') return { value: '', unit: 'ans' }
    const number = Number(months)
    return number > 0 && number % 12 === 0
        ? { value: number / 12, unit: 'ans' }
        : { value: number, unit: 'mois' }
}

export function ageFields(config = {}) {
    const min = config.min_age_months === undefined ? null : config.min_age_months
    const max = config.max_age_months === undefined ? null : config.max_age_months
    const preset = Object.keys(PRESETS).find(key => PRESETS[key].min_age_months === min && PRESETS[key].max_age_months === max)
    const lower = inputFor(min)
    const upper = inputFor(max)
    return { mode: preset || 'CUSTOM', minValue: lower.value, minUnit: lower.unit,
        maxValue: upper.value, maxUnit: upper.unit }
}
